var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgQArrowUpGreen = function SvgQArrowUpGreen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#E6F5EB",
    rx: 4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2BAB63",
    d: "m9.298 8.412-2.306 2.093L6 9.622 10 6l4 3.62-.974.886-2.306-2.094V14H9.298z"
  })));
};
export { SvgQArrowUpGreen as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3Qgd2lkdGg9IjIwIiBoZWlnaHQ9IjIwIiByeD0iNCIgZmlsbD0iI0U2RjVFQiIvPgo8cGF0aCBkPSJNOS4yOTgwMyA4LjQxMjA5TDYuOTkyNDQgMTAuNTA1NUw2IDkuNjIwODhMMTAgNkwxNCA5LjYyMDg4TDEzLjAyNTcgMTAuNTA1NUwxMC43MjAxIDguNDEyMDlWMTRIOS4yOTgwM1Y4LjQxMjA5WiIgZmlsbD0iIzJCQUI2MyIvPgo8L3N2Zz4K";